<template>
    <div>
        <select 
            class="form-control billing-period-select"
            @change="sendSelection($event.target.value)"
        >
            <option value="" disabled selected>Select billing period</option>
            <option 
                v-for="option in arrayOptions" 
                :key="option" 
                :value="option"
            >
                {{ option }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        baseArray: {
            type: Array,
            required: true
        },
    },
    computed: {
        arrayOptions() {
            if (this.baseArray.length > 0) {
                var filteredArray;
                if (this.baseArray[0].billingPeriod) {
                    filteredArray = [];

                    for (let i = 0; i < this.baseArray.length; i++) {
                        filteredArray.push(this.getLabel(this.baseArray[i].billingPeriod));
                    }

                    return [...new Set(filteredArray)];
                }
                if (this.baseArray[0].period) {
                    filteredArray = [];

                    for (let i = 0; i < this.baseArray.length; i++) {
                        filteredArray.push(this.getLabel(this.baseArray[i].period));
                    }

                    return [...new Set(filteredArray)];
                }
            } else {
                return [];
            }
        }
    },
    methods: {
        sendSelection(value) {
            if (this.baseArray.length > 0) {
                var filteredList;
                if (this.baseArray[0].billingPeriod) {
                    filteredList = []

                    for (let i = 0; i < this.baseArray.length; i++) {
                        if (this.baseArray[i].billingPeriod == this.horrifyBillingPeriod(value)) {
                            filteredList.push(this.baseArray[i]);
                        }
                    }

                    this.$emit('selectedOption', filteredList);
                }
                if (this.baseArray[0].period) {
                    filteredList = []

                    for (let i = 0; i < this.baseArray.length; i++) {
                        if (this.baseArray[i].period == this.horrifyBillingPeriod(value)) {
                            filteredList.push(this.baseArray[i]);
                        }
                    }

                    this.$emit('selectedOption', filteredList);
                }
            } else {
                return [];
            }
        },
        horrifyBillingPeriod(period) {
            var Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            var year = period.substring(period.length-4, period.length);
            var month = '0';

            for (let i = 0; i < Months.length; i++) {
                if (period.includes(Months[i])) {
                    if (i < 9) {
                        month = '0' + (i+1);
                    } else {
                        month = (i+1);
                    }
                }
            }

            var output = year + '' + month;
            return parseInt(output);
        },
        getLabel(period) {
            return this.prettifyBillingPeriod(period);
        },
    },
}
</script>

<style scoped>
.billing-period-select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    font-size: 1rem;
    cursor: pointer;
    appearance: auto;
}

.billing-period-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
